import { BASE_URL, HTTP, isEndpoint } from "./config";
import Cookies from 'js-cookie';

function createQueryParams(queryParams) {
  if(!Array.isArray(queryParams)) throw new Error('Not an array');

  const isKeyValuePairArray = queryParams.every((queryParam) => {
    const key = Object.keys(queryParam)[0];

    const isKey = !!key;
    if(!isKey) throw new Error('All objects in this array should be { key: value }');

    const isValue = !!queryParam[key];
    if(!isValue) throw new Error('Undefined key or non existent pair');
    return true;
  });

  return isKeyValuePairArray && queryParams.reduce((acc, queryParam) => 
    `${acc && `${acc}&`}${Object.keys(queryParam)[0]}=${queryParam[Object.keys(queryParam)[0]]}`
  , '');
}

const dataFetch = (method = 'POST', endpoint, body, queryParams, routeParams) => {
  isEndpoint(endpoint);

  const url = BASE_URL + "/" + endpoint +
    `${(routeParams && `/${routeParams.join('/')}`) ?? ''}` +
    `${(queryParams && `?${createQueryParams(queryParams)}`) ?? ''}`;

    const headers = {
        'authorization': `Bearer ${Cookies.get('token')}`,
    };

  // Solo agregar Content-Type si no es FormData
  if (!(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(url, {
    method,
    ...(method !== HTTP.GET && { body: body instanceof FormData ? body : JSON.stringify(body) }),
    headers,
  });
};



export async function fetchFromLawfeed({ method, endpoint, body, queryParams, routeParams }) {
  try {
    let response;
    let responseJson;

        while ((!response || response.status === 403 || response.status === 401) && 
            (!responseJson || responseJson.error)) 
        {
            // Intenta refrescar el token solo una vez para evitar bucles infinitos
            if (response && responseJson && 
                (response.status === 403 || response.status === 401) 
                && responseJson.error) 
            {
                const refreshResponse = await refreshToken();
                if (!refreshResponse.ok) throw new Error('No se pudo refrescar el token');
            }

      // Envío de la solicitud
      response = await dataFetch(method, endpoint, body, queryParams, routeParams);

      // Intentar leer JSON, pero capturar el error si no es JSON
      try {
        responseJson = await response.json();
      } catch (jsonError) {
        console.warn('No se recibió JSON en la respuesta:', jsonError);
        responseJson = null; // Establecer como null si no es JSON
      }
    }

    // Manejo de errores para respuestas no exitosas
    if (response.status !== 403 && !(response.status >= 200 && response.status < 300)) {
      const errorText = responseJson?.error || 'No error message available';
      throw new Error(`Error in fetchFromLawfeed: status: ${response.status}, error: ${errorText}`);
    }

    return responseJson;
  } catch (error) {
    console.error('Error en fetchFromLawfeed:', error);
    throw error;
  }
}

export const refreshToken = async () => {
    try {
        const response = await fetch(`${BASE_URL}/auth/refresh`, {
            method: 'POST',
            headers: { 
                'Authorization': `Bearer ${Cookies.get('refreshToken')}`
            },
        });

        if (response.ok) {
            const data = await response.json();
            console.log('Token refreshed:', data);
            
            Cookies.set('token', data.token);
            return { ok: true, data };
        } else {
            return { ok: false, error: response.ok };
        }
    } catch (error) {
        console.error('Token refresh error:', error);
        return { ok: false, error };
    }
};